(() => {
  if (!customElements.get("product-set-options")) {
    customElements.define(
      "product-set-options",
      class ProductSetOptions extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          /* ===== Cache the DOM elements and attach the event listeners ===== */
          this.addEventListeners();

          // Fix for the back button
          setTimeout(() => {
            this.handleOptionChange();
          }, 250);
        }

        disconnectedCallback() {
          /* ===== Clean up event listeners when component is disconnected ===== */
          this.detachEventListeners();
        }

        get options() {
          return [...this.querySelectorAll('input[type="checkbox"]')];
        }

        get selectedOptionsInput() {
          return this.querySelector("[data-selected-options]");
        }

        get productForm() {
          return this.closest("product-information");
        }

        get sectionId() {
          return this.getAttribute("data-section-id");
        }

        addEventListeners() {
          /* ===== Attach the event listeners to the DOM elements ===== */
          this.options.forEach((option) => {
            option.addEventListener(
              "change",
              this.handleOptionChange.bind(this)
            );
          });

          window.addEventListener(
            "pageshow",
            this.handleOptionChange.bind(this)
          );
        }

        detachEventListeners() {
          /* ===== Detach the event listeners from the DOM elements ===== */
          this.options.forEach((option) => {
            option.removeEventListener(
              "change",
              this.handleOptionChange.bind(this)
            );
          });

          window.removeEventListener(
            "pageshow",
            this.handleOptionChange.bind(this)
          );
        }

        getData(sectionId) {
          return JSON.parse(this.getDataElement(sectionId).textContent);
        }

        getDataElement(sectionId) {
          return this.querySelector(
            `script[type="application/json"][data-resource="${sectionId}"]`
          );
        }

        updateOptionsState() {
          const { variantLimit } = this.getData(this.sectionId);
          const selectedOptionsCount = this.options.filter(
            (option) => option.checked
          ).length;

          this.options.forEach((option) => {
            if (
              selectedOptionsCount === variantLimit &&
              this.options.length === variantLimit
            ) {
              // All available options are checked and the variant limit is reached
              option.disabled = true;
              return;
            }

            if (selectedOptionsCount === variantLimit && !option.checked) {
              // The option is not checked but the variant limit is reached
              option.disabled = true;
              return;
            }

            option.disabled = false;
          });

          if (selectedOptionsCount >= variantLimit) {
            this.toggleAddButton(false);
          } else {
            this.toggleAddButton(true);
          }
        }

        toggleAddButton(disable = true) {
          /* ===== Toggle the state of the add to cart button ===== */
          const addButton = this.productForm.querySelector('[name="add"]');
          if (!addButton) return;

          addButton.disabled = disable;
        }

        handleOptionChange() {
          /* ===== Handle the click event on the options ===== */
          this.updateOptionsState();
          this.updateSelectedOptionsInput();
        }

        updateSelectedOptionsInput() {
          if (!this.selectedOptionsInput) {
            return;
          }

          const selectedOptions = this.options
            .filter((option) => option.checked)
            .map((option) => option.value);
          this.selectedOptionsInput.value = selectedOptions.join(", ");
        }
      }
    );
  }
})();
